import React, { useEffect, useState } from 'react';
import { Grid, TextareaAutosize } from '@material-ui/core';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import { InputProps } from './types';
import { useStyles } from './styles';
import FormControl from '@material-ui/core/FormControl';
import { validate } from './validator';
import { useDispatch, useSelector } from 'react-redux';
import { setCustomData } from '../../Reducers/Configurator/Actions';
import { setProductParamsValid } from '../../Reducers/App/Actions';
import { getCustomData, getProductParamValidations } from '../../Reducers/App/Selectors';
import clsx from 'clsx';

const CWTextArea: React.FC<InputProps> = (props) => {
  const { field, numRows } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const validations = useSelector(getProductParamValidations);

  const storedValue = useSelector((state) => getCustomData(state)?.[field.identifier]);

  const [value, setValue] = useState(storedValue || '');
  const [pristine, setPristine] = useState(true);

  const isFieldValid =
    validations[field.identifier] === undefined || validations[field.identifier] === true || pristine;

  useEffect(() => {
    if (!pristine) {
      const timeout = setTimeout(() => validateField(), 2000);

      return () => {
        clearTimeout(timeout);
      };
    }
  }, [value]);

  const handleChange = (e) => {
    enterValue(e);
  };

  const enterValue = (e) => {
    setValue(e.target.value);
    setCustomField(e);
  };

  const validateField = () => {
    if (field.validation) {
      const result = validate(value, field.validation);
      dispatch(setProductParamsValid({ [field.identifier]: result }));
    } else {
      dispatch(setProductParamsValid({ [field.identifier]: true }));
    }
  };

  const setCustomField = (e) => {
    dispatch(setCustomData({ [field.identifier]: e.target.value }));
  };

  return (
    <Grid container className={classes.component} style={{ margin: 0, minWidth: 'auto' }}>
      <Grid item xs={12}>
        <FormControl key={field.identifier} className={classes.formControl}>
          <TextareaAutosize
            placeholder={field.placeholderSlug ? t(field.placeholderSlug) : field.placeholder}
            className={clsx(classes.textField, classes.textArea)}
            onChange={handleChange}
            onBlur={validateField}
            value={value}
            minRows={numRows ? numRows : 6}
            onFocus={() => setPristine(false)}
          />
        </FormControl>
      </Grid>
    </Grid>
  );
};

export default CWTextArea;
